import { VideoStreamProviderService } from './../video-stream-provider.service';
import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { take } from 'rxjs/operators';
import { ToastService } from '../../_core/services/toast.service';
import { Camera } from '../../_shared/models/camera.model';
import { Match } from '../../_shared/models/match.model';

@Component({
  standalone: false,
  selector: 'app-manage-cameras',
  templateUrl: './manage-cameras.component.html',
  styleUrls: ['./manage-cameras.component.scss'],
})
export class ManageCamerasComponent {
  private videoStreamProviderService = inject(VideoStreamProviderService);
  private toastService = inject(ToastService);

  @Input() cameras: Camera[];
  @Input() partner: string;
  @Input() match: Match;
  @Output() updateCameras = new EventEmitter<boolean>();

  token: string;
  showAddCamera: boolean;

  constructor() { }

  saveToken() {
    this.videoStreamProviderService
      .updateMatchCameras(this.partner, this.token, this.match?._id)
      .pipe(take(1))
      .subscribe({
        next: async res => {
          this.showAddCamera = false;
          this.updateCameras.emit(true);
        }
      })
  }

  removeCamera(camera: Camera, index: number) {
    this.videoStreamProviderService
      .removeCamera(camera, this.match._id)
      .pipe(take(1))
      .subscribe({
        next: res => {
          this.cameras.splice(index, 1);
          this.handleRemoveCamera()
          this.toastService.presentToast(res.message);
        }
      })
  }

  private handleRemoveCamera() {
    const camIndex = this.match.cameras.findIndex(c => c.partner === this.partner);
    this.match.cameras.splice(camIndex, 1);
  }
}
